var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.999 8.00391H26.8516V11.4313H27.999V8.00391Z",
    fill: "#4CF038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8509 11.4297H25.7109V14.8571H26.8509V11.4297Z",
    fill: "#4CF038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7103 14.8555H24.5703V17.1429H25.7103V14.8555Z",
    fill: "#4CF038"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5772 10.2891H23.4297V13.7165H24.5772V10.2891Z",
    fill: "#4CF038"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5703 17.1445H13.1406V18.2845H24.5703V17.1445Z",
    fill: "#4CF038"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4212 13.7188H22.2812V15.9987H23.4212V13.7188Z",
    fill: "#4CF038"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 10.2891H18.8594V15.9964H19.9993V10.2891Z",
    fill: "#4CF038"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5693 13.7188H15.4219V15.9987H16.5693V13.7188Z",
    fill: "#4CF038"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4212 10.2891H14.2812V13.7165H15.4212V10.2891Z",
    fill: "#4CF038"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1397 21.7135V22.861H14.2796V24.001H16.5671V22.861H17.707V21.7135H19.9944V22.861H21.1344V24.001H23.4218V22.861H24.5693V21.7135H26.8492V20.5736H23.4218V19.4336H21.1344V20.5736H16.5671V19.4336H14.2796V20.5736H11.9922V21.7135H13.1397Z",
    fill: "#4CF038"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1397 18.2852H11.9922V19.4326H13.1397V18.2852Z",
    fill: "#4CF038"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1397 13.7188H11.9922V17.1461H13.1397V13.7188Z",
    fill: "#4CF038"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9915 19.4336H10.8516V20.5736H11.9915V19.4336Z",
    fill: "#4CF038"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9915 10.2891H10.8516V13.7165H11.9915V10.2891Z",
    fill: "#4CF038"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8509 10.2865V7.99903H26.8479V6.85156H9.71094V10.2865H10.8509Z",
    fill: "#4CF038"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70997 4.57812H8.5625V6.85806H9.70997V4.57812Z",
    fill: "#4CF038"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56965 2.28516H7.42969V4.57259H8.56965V2.28516Z",
    fill: "#4CF038"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42872 1.14062H6.28125V2.28809H7.42872V1.14062Z",
    fill: "#4CF038"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27993 0H4V1.13997H6.27993V0Z",
    fill: "#4CF038"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88672 36.5117H0.910156V29.6758H1.88672V30.6523H2.375V31.1406H2.86328V31.6289H3.83984V31.1406H4.32812V30.6523H4.81641V29.6758H5.79297V36.5117H4.81641V32.1172H4.32812V32.6055H3.83984V33.582H2.86328V32.6055H2.375V32.1172H1.88672V36.5117ZM7.74609 33.582H10.6758V32.1172H10.1875V31.6289H9.69922V31.1406H8.72266V31.6289H8.23438V32.1172H7.74609V33.582ZM7.74609 36.5117H6.76953V31.6289H7.25781V31.1406H7.74609V30.6523H8.23438V30.1641H8.72266V29.6758H9.69922V30.1641H10.1875V30.6523H10.6758V31.1406H11.1641V31.6289H11.6523V36.5117H10.6758V34.5586H7.74609V36.5117ZM13.6055 30.6523V32.6055H16.0469V32.1172H16.5352V31.1406H16.0469V30.6523H13.6055ZM14.0938 33.582H13.6055V36.5117H12.6289V29.6758H16.5352V30.1641H17.0234V30.6523H17.5117V32.6055H17.0234V33.0938H16.5352V33.582H15.5586V34.0703H16.0469V34.5586H16.5352V35.0469H17.0234V35.5352H17.5117V36.5117H16.5352V36.0234H16.0469V35.5352H15.5586V35.0469H15.0703V34.5586H14.582V34.0703H14.0938V33.582ZM19.4648 33.582V36.5117H18.4883V29.6758H19.4648V32.6055H19.9531V32.1172H20.4414V31.6289H20.9297V31.1406H21.418V30.6523H21.9062V30.1641H22.3945V29.6758H23.3711V30.6523H22.8828V31.1406H22.3945V31.6289H21.9062V32.1172H21.418V32.6055H20.9297V33.582H21.418V34.0703H21.9062V34.5586H22.3945V35.0469H22.8828V35.5352H23.3711V36.5117H22.3945V36.0234H21.9062V35.5352H21.418V35.0469H20.9297V34.5586H20.4414V34.0703H19.9531V33.582H19.4648ZM29.2305 29.6758V30.6523H25.3242V32.6055H28.2539V33.582H25.3242V35.5352H29.2305V36.5117H24.3477V29.6758H29.2305ZM32.1602 30.6523H30.207V29.6758H35.0898V30.6523H33.1367V36.5117H32.1602V30.6523Z",
    fill: "#4CF038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.9c099fe32d735d8f35426024ea585221.svg";
export { ForwardRef as ReactComponent };